// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55777c17","453":"42612aea","455":"8b4d2d39","977":"6a43e744"}[chunkId] + ".chunk.js";
};